<template>
  <div></div>
</template>

<script>
export default {
  name: "TemporaryPage",
};
</script>
